module.exports = __webpack_public_path__ + "img/code.ffca8605.png";